import { useRef } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 1, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, inView = false, className = "" }) => {
  const ref = useRef(null);
  const visible = useInView(ref, { once: true, margin: "-60px" });
  const show = inView ? visible : true;
  return (
    <span ref={ref} className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "112%" }}
        animate={show ? { y: "0%" } : {}}
        transition={{ duration: 1.15, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const ChapterTag = ({ num, label, light = false }) => (
  <Reveal className="flex items-center gap-5">
    <span
      className={`font-display text-lg italic ${
        light ? "text-[#A98B5F]" : "text-[#064E3B]"
      }`}
    >
      {num}
    </span>
    <span className={`h-px w-14 ${light ? "bg-[#F5F5F4]/30" : "bg-[#1C1917]/25"}`} />
    <span
      className={`text-xs font-medium uppercase tracking-[0.32em] ${
        light ? "text-[#F5F5F4]/70" : "text-[#57534E]"
      }`}
    >
      {label}
    </span>
  </Reveal>
);
